import {Box, Button, Paper, TableBody, TableContainer, TableHead, TableRow } from '@mui/material'
import React, { useState } from 'react'
import EmptyListPlaceholder from '../Common/EmptyListPlaceholder'
import { CustomTableRowTR, StyledTable, TableData, TableHeader, TableWrapper } from '../../styles/commonStyles'
import EventBus from '../../EventBus';
import { EventBusEventsEnum } from '../../enums/EventBusEventsEnum';
import { CustomSnackbarTypes } from '../Common/CustomSnackBar';
import AddIngredientDialogOms from '../Common/AddIngredientDialogOms';

function OneMealServiceIngredientList(props: any) {
  const [addIngredientModel, setAddIngredientModel] = useState(false);
  const [selectedData, setSelectedData] = useState<any>(null);

  const copyListToClipboard = () => {
    const ingredientList = props?.ingredientList.map((item: any) => {
      return `${item?.ingredientName} ${getQunatity(item)}`;
    }).join('\n');
    
    navigator.clipboard.writeText(ingredientList)
          .then(() => {
            EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
            message: "All dish information copied to clipboard!",
            type: CustomSnackbarTypes.SUCCESS,
          });
          })
          .catch(err => {
              console.error('Failed to copy text: ', err);
  });
}

  function getQunatity(row: any) {
    if (row?.quantityEdited && Number(row?.quantityEdited) > 0) {
      return `- ${row?.quantityEdited} ${row?.unit}`;
    } else if(row?.quantity && Number(row?.quantity) > 0) {
      return `- ${row?.quantity} ${row?.unit}`;
    }
    return '';
  }
  return (
    <div>
        <TableWrapper>
          <Box sx={{display: 'flex', justifyContent:'flex-end', padding: '8px 16px'}}><Button onClick={() => copyListToClipboard()}>Copy List</Button></Box>
          <TableContainer component={Paper} sx={{ borderRadius: "8px" }}>
            <StyledTable>
              <TableHead>
                <TableRow sx={{ backgroundColor: "rgba(232,235,237,0.3) !important" }}>
                  <TableHeader>Ingredient Name</TableHeader>
                  <TableHeader>Quantity</TableHeader>
                  <TableHeader>Edit</TableHeader>
                </TableRow>
              </TableHead>
              <TableBody>
                {props?.ingredientList.length ? props?.ingredientList.map((row: any) => (
                  <CustomTableRowTR key={row?.profile?.id}>
                    <TableData>{row?.ingredientName}</TableData>
                    <TableData>{`${row?.quantityEdited ? row?.quantityEdited : row?.quantity} ${row?.unit}`}</TableData>
                    <TableData>
                      <Button onClick={() => {
                        setAddIngredientModel(true)
                        setSelectedData(row)
                      }}>update</Button>
                    </TableData>
                  </CustomTableRowTR>
                )) : <EmptyListPlaceholder message='No Ingredient List Available'/>}
              </TableBody>
            </StyledTable>
          </TableContainer>
        </TableWrapper>
      {
        addIngredientModel && 
        <AddIngredientDialogOms
          open={addIngredientModel}
          callback={() => setAddIngredientModel(false)}
          data={selectedData}
          type='update'
        />
      }
    </div>
  )
}

export default OneMealServiceIngredientList